var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Grid } from '../../components/Grid/index';
export class ShowPreview extends Component {
    constructor() {
        super('ShowPreview', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.button-more-informations').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                let triangle = button.find('.triangle');
                let loading = button.find('.loading');
                let parent = button.parents('.module-show-preview');
                let show_details = parent.find('.show-details');
                if (button.data('status') == 'loading')
                    return;
                if (button.data('status') == 'loaded') {
                    button.data('status', 'unloaded');
                    triangle.addClass('triangle-bottom').removeClass('triangle-top');
                    loading.addClass('d-none');
                    show_details.removeClass('mt-20').css('max-height', '0px');
                }
                else {
                    button.data('status', 'loading');
                    loading.removeClass('d-none');
                    var show_details_html = yield $.httpRequest({
                        url: parent.find('a').eq(0).attr('href') + '?action=get_details',
                        dataType: 'html',
                    });
                    show_details.find('.content').empty().append(show_details_html);
                    yield $.imagesLoaded(show_details_html.find('img'));
                    Grid.initGrid(show_details_html.find('.grid'));
                    show_details.addClass('mt-20').css('max-height', show_details.find('.content').height() + 'px');
                    triangle.addClass('triangle-top').removeClass('triangle-bottom');
                    loading.addClass('d-none');
                    button.data('status', 'loaded');
                }
            }));
            this.success();
        });
    }
}
